<template>
  <div class="categories" style="background: white">
    <v-card-text v-if="blog_data.items!=null">
      <div>

        <div class="page-title">
          <div class="row">
            <v-col cols="8"><h1
              style="font-size: 20px;text-align: right">{{blog_data['items']['SearcQusInfo']['QusTitle']}}</h1></v-col>

          </div>
        </div>

      </div>
      <v-row>

        <v-col cols="12 col-sm-9 col-lg-9 col-md-9" style="padding: 5px">

          <article id="post-53"
                   class="post-53 post type-post status-publish format-standard has-post-thumbnail hentry category-featured tag-css tag-school tag-wordpress node node-blog">

            <div class="body field blog-body" style="    text-align: justify;"
                 v-html="blog_data['items']['SingleQuestion']['Text']">
            </div>
            <div class="post-info">
              <span class="post-author"><i class="fa-user fa"></i>{{ $t('zoodkomak') }}</span>

            </div>
<v-row v-if="blog_data['items']['SingleQuestion']['Images']!=null && blog_data['items']['SingleQuestion']['Images'].length>0">
  <v-col v-for="img in blog_data['items']['SingleQuestion']['Images']">
    <a  :href="img['ArchivePath']" target="_blank"><img :src="img['ArchivePath']" style="margin:10px;width: 100px;height:100px"/></a>
  </v-col>
</v-row>

            <div class="post-info">
                        <span class="post-date"><i class="fa-calendar fa"></i>
                          {{get_date_time(blog_data['items']['SingleQuestion']['CreatedAt'])}}
                        </span>
              <span class="post-author"><i class="fa-user fa"></i>{{blog_data['items']['SingleQuestion']['SenderName']}}</span>

            </div>
            <br>

            <strong>{{ $t('asnwers') }}</strong>
            <br>
<v-row v-for="keyword in blog_data['items']['AnswerRelQuestion']" >
  <div class="answer-row">
    <p  v-html="keyword['Text']"></p>
    <p>{{ keyword['SenderName'] }}</p>
    <p>{{get_date_time(keyword.CreatedAt)}}</p>
    <div v-for="image in keyword['Images']">
      <img :src="image['ArchivePath']" :href="image['ArchivePath']" target="_blank" style="margin:10px;width: 100px;height:100px"/>

    </div>

  </div>

</v-row>



<!--            <section id="respond">-->
<!--              <h3>نظر خود را بنویسید</h3>-->
<!--            <v-row>-->

<!--              <v-col cols="6">-->
<!--                <v-row>-->
<!--                  <v-col cols="12">-->
<!--                    <v-text-field-->
<!--                      label="نام و نام خانودگی"-->
<!--                      outlined-->
<!--                      dense-->
<!--                      v-model="comment_name"/>-->
<!--                  </v-col>-->
<!--                  <v-col cols="12">-->
<!--                    <v-text-field-->
<!--                      outlined-->
<!--                      dense-->
<!--                      label="شماره موبایل" v-model="comment_mobile"/>-->
<!--                  </v-col>-->
<!--                  <v-col cols="12">-->
<!--                    <div id="comment_editor" style="height: 150px"></div>-->

<!--&lt;!&ndash;                    <v-text-field v-model="comment_text"&ndash;&gt;-->
<!--&lt;!&ndash;                                  outlined&ndash;&gt;-->
<!--&lt;!&ndash;                                  dense&ndash;&gt;-->
<!--&lt;!&ndash;                                  label="نظر"&ndash;&gt;-->
<!--&lt;!&ndash;                    />&ndash;&gt;-->
<!--                  </v-col>-->
<!--                  <v-col cols="12">-->
<!--                    <v-btn-->
<!--                      id="add_comment_btn"-->
<!--                      outlined-->

<!--                      @click="add_blog_comment()"-->
<!--                    >ثبت نظر-->
<!--                    </v-btn>-->
<!--                  </v-col>-->





<!--                </v-row>-->

<!--              </v-col>-->
<!--              -->
<!--            </v-row>-->
              <div>
                <h3>{{ $t('userComments') }}</h3>
                <div v-for="comment in blog_data['items']['PageComments'] " v-if="comment['AcceptType']==1"
                     class="comment-box row">
                  <div class="large-6 columns">
                    <h6>{{comment['UserName']}}</h6>
                  </div>
                  <div class="large-6 columns">
                    <h6 style="text-align: left">{{comment['CreatedAt']}}</h6>
                  </div>
                  <p style="color: #000;font-size: 16px;">{{comment['CommentText'] }}</p>
                </div>

              </div>
            </section>

          </article>
        </v-col>

        <v-col cols="12 col-sm-3 col-lg-3 col-md-3" style="padding: 5px" id="aside_blog">
          <div class="col-lg-12">

            <div class="col-lg-12 p-1 m-1" style="margin:3px">
              <img width="100%" src="/images/sidebars/saat_kari_24.jpg" class="img-fluid" alt="ساعت کاری زودکمک">
            </div>
            <div class="col-lg-12 p-1 m-1" style="margin:3px">
              <img width="100%" src="/img/golden_card.png" class="img-fluid" alt="ساعت کاری زودکمک">
            </div>
            <!-- پایان -->
            <!-- عکس تعمیر موبایل -->
            <div class="col-lg-12 p-2 m-1" style="margin:3px">
              <a href="https://cp.zoodkomak.com/pages/Request/mobile-repair">
                <img width="100%" src="/images/sidebars/Edit1.jpg" class="img-fluid" alt="تعمیر موبایل در محل">
              </a>
            </div>
            <!-- پایان -->
            <!-- عکس تعمیر لپ تاپ -->
            <div class="col-lg-12 p-2 m-1" style="margin:3px">
              <a href="https://cp.zoodkomak.com/pages/Request/laptop-repair">
                <img width="100%" src="/images/sidebars/Edit2.jpg" class="img-fluid" alt="تعمیر لپ تاپ در محل">
              </a>
            </div>
            <!-- پایان -->
            <!-- عکس تعمیر لوازم خانگی -->
            <div class="col-lg-12 p-2" style="margin:3px">
              <a href="https://cp.zoodkomak.com/pages/Request/refrigerator-repair">
                <img width="100%" src="/images/sidebars/InCollection.jpg" class="img-fluid" alt="تعمیر لوازم خانگی">
              </a>
            </div>
            <!-- پایان -->
          </div>
          <div id="recent-posts-2" class="widget widget_recent_entries clearfix">
            <h2 class="block-title">{{ $t('relatedPosts') }}</h2>
            <ul v-for="related in blog_data['items']['VmRelatedPageInfos']">
              <li>
                <a style="color: black" :href="related['CanonicalUrl']" aria-current="page">
                  <img width="100%" :src="related['ImageUrl']"/>{{related['PageTitle']}}
                </a>
              </li>
              <br>
              <hr>

            </ul>

          </div>

          <a class="e-namad" referrerpolicy="origin" target="_blank"
             href="https://trustseal.enamad.ir/?id=303769&amp;Code=WAxrXd5NiVjyjgIB3wZK"><img loading="lazy"
                                                                                              referrerpolicy="origin"
                                                                                              src="https://Trustseal.eNamad.ir/logo.aspx?id=303769&amp;Code=WAxrXd5NiVjyjgIB3wZK"
                                                                                              alt=""
                                                                                              style="cursor:pointer"
                                                                                              id="WAxrXd5NiVjyjgIB3wZK"></a>

        </v-col><!-- #secondary -->
      </v-row>

    </v-card-text>
  </div>
</template>
<script>

  import {bus} from "../../main";

  export default {
    components: {},
    data() {
      return {
        blog_data: {},
        isMobile: false,
        selected_item_id: '',
        last_class_name: '',
        comment_name: '',
        comment_mobile: '',
        comment_text: '',
        errors: [],
        page: 1,
        quill:null,
      }
    },
    watch: {},
    mounted() {
      this.get_blogs()

    },
    methods: {
       add_blog_comment() {
var self = this;
    // var comment_text = $('#comment_text').val();
    var comment_text =  this.quill.root.innerHTML;
    console.log("comment text  is",comment_text)
    if(this.comment_name==null || this.comment_name==""){
      bus.$emit('show_toast', [1500, this.$t('writeYourName')])
      return
    }
    if(this.comment_mobile==null || this.comment_mobile==""){
      bus.$emit('show_toast', [1500, this.$t('writeYourNo')])
      return
    }
    if(this.comment_mobile.toString().substring(0,2)!="09" || this.comment_mobile.length!=11){
      bus.$emit('show_toast', [1500, this.$t('enterNumberCorrect')])
      return
    }
    if(comment_text==null || comment_text=="" || comment_text=="<p><br></p>"){
      bus.$emit('show_toast', [1500, this.$t('writeYourComment')])
      return
    }
         var send_data = {
           PageId: this.blog_data.items.VmPage.Id,
           Phone:this.comment_mobile,
           Name:this.comment_name,
           CommentTxt:comment_text
    }
         this.axios.post('https://panel.zoodkomak.com/jetToken/AddPageComment', send_data, {})
           .then(response => {
             self.comment_name = "";
             self.comment_mobile = "";
             self.quill.root.innerHTML="";
             bus.$emit('show_dialog', [this.$t('yourCommentSubmited'),this.$t('commenShowAfter')])

           }).catch(e => {
           this.errors.push(e)
         })


  },

  resize_mobile() {
        if (window.innerWidth < 600) {
          this.isMobile = true
        } else {
          this.isMobile = false
        }
      },
      get_blogs() {
        var self = this

        var send_data = {
          urlGroup: this.$route.params.keyword,
          pageKeyword: this.$route.params.keyword,
          refe: ''
        }
        this.axios.post('https://panel.zoodkomak.com/jetToken/GetQuestionInfo', send_data, {})
          .then(response => {
            self.blog_data = response.data;
            setTimeout(() => {

              var container = document.getElementById('comment_editor')
              self.quill = new Quill(container, {
                modules: {
                  toolbar: [
                    // [{ header: [1, 2, false] }],
                    ['link'],
                  ]
                },
                theme:'snow',
                placeholder: this.$t('writeYourComment'),
              });
              }, 1000);


          }).catch(e => {
          this.errors.push(e)
        })
      },

      get_item_color(item_id) {
        if (item_id == this.selected_item_id) {
          return '#cee2f7'
        } else {
          return 'white'
        }
      },
      add_request(id, cat_id, title) {
        // if (this.dataset.post_id != null) {
        // localStorage.setItem("RequestPostId", id);
        // localStorage.setItem("RequestPostName", title);
        // localStorage.setItem("RequestPostBrand",cat_id);
        // window.open('/#AddRequest', "_self");
        // var passing_data = JSON.parse(localStorage.getItem('request_data'))
        var passing_data = JSON.parse(localStorage.getItem('request_data'))

        // passing_data.sub_group_id = item_id
        // passing_data.request_name = passing_data.request_name + title + ' '
        passing_data.post_id = id
        passing_data.post_name = title
        passing_data.post_brand_id = cat_id

        localStorage.setItem('request_data', JSON.stringify(passing_data))
        this.$router.push({name: 'request_detail', params: {}})

        // this.$router.push({ path: 'brands', params: {} })

        // }
      },
      post_view(id) {
        window.open('https://bilbordz.com/api/view_post/' + id)
      },

      goToDetail(item_id) {
        var passing_data = JSON.parse(localStorage.getItem('request_data'))
        passing_data.group_id = item_id
        localStorage.setItem('request_data', JSON.stringify(passing_data))
        this.$router.push({path: 'subgroups', params: {}})
      },
      get_categories() {
        // console.log("datas is "+localStorage.getItem('request_data'))
        var self = this
        var passing_data = JSON.parse(localStorage.getItem('request_data'))
        var cat_id = passing_data.sub_group_id

        const send_data = {
          groupId: cat_id,
        }
        var formData = new FormData()
        formData.append('groupId', cat_id)
        // this.axios.post('/Register' , send_data,{
        this.axios.post('https://cp.zoodkomak.com/api/get_group_posts', formData, {})
          .then(response => {
            if (response.data.error == 0) {
              // console.log("response", response);
              // self.fullName = response.data.msg;
              self.items = response.data.posts
              // self.level = 2;
            }
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      }
    }
  }
</script>
<style>

  .sidebar-right ul li {
    list-style: none;
  }

  hr {
    border: solid #dddddd;
    border-width: 1px 0 0;
    clear: both;
    margin: 1.25rem 0 1.1875rem;
    height: 0;
  }

  img {
    max-width: 100%;
  }
   .ql-container {
     font-family: IRANSans!important;
     text-align: right!important;
   }
  .ql-editor {
    font-family: IRANSans!important;
    text-align: right!important;
  }
  .comment-box a{
    color:blue;
  }
  .answer-row {
    direction: rtl;
    position: relative;
    margin: 10px !important;
    -webkit-box-shadow: 0 10px 10px -5px;
    padding: 10px;
    text-align: right;
    /* display: flex; */
    flex-wrap: wrap;
    box-shadow: 0 10px 10px -5px;
    border-radius: 6px;
    background: white;
    color: black;
  }
</style>
